import { MGColors, MGComponentColors } from "./colors";

export const getMGColorStyles = () => {
  const palette = Object.keys(MGColors).map((key) => {
    const color = MGColors[key as keyof typeof MGColors];
    return `--mg-color-${key}: ${color.hex};`;
  });
  const components = Object.keys(MGComponentColors).map(
    (key) => `--mg-color-${key}: ${MGComponentColors[key as keyof typeof MGComponentColors]};`,
  );
  return `:root {\n${palette.concat(components).join("\n")}\n}`;
};

export const installMGColorStyles = () => {
  if (typeof document === "undefined") return;
  const id = "mg-design-system-colors";
  let style = document.getElementById(id);
  if (!style) {
    style = document.createElement("style");
    style.id = id;
    document.head.appendChild(style);
  }
  style.textContent = getMGColorStyles();
};

installMGColorStyles();
